import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import UploadSection from "./UploadSection";
import History from "../../../../Analysis/ComponentsAnalysis/HistoryAdequacao/History";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";

const Topic = ({
  data,
  hasError,
  onOptionSelect,
  onFileUpload,
  idResposta,
  uploadedFiles,
  selectedOptions,
  disabled,
  onAnalysisChange,
  historico,
  modoAdequacao,
  isOpen: isOpenProp,
  onToggle: onToggleProp,
}) => {
  const [selectedMainOption, setSelectedMainOption] = useState("");
  const [selectedPaths, setSelectedPaths] = useState({});

  const [localOpen, setLocalOpen] = useState(false);
  const isControlled = isOpenProp !== undefined && typeof onToggleProp === "function";
  const isOpen = isControlled ? isOpenProp : localOpen;
  const handleToggle = isControlled ? onToggleProp : () => setLocalOpen((prev) => !prev);

  function slugify(text) {
    let slug = text
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
    slug = slug.replace(/^\d+-/, "");
    return slug;
  }

  const temaSlug = slugify(data.idCampoJson);

  const emAdequacaoDesteCampo =
    modoAdequacao &&
    typeof historico?.[temaSlug]?.dataSolicitacao === "string" &&
    historico?.[temaSlug]?.adequacaoRealizada !== true;

  const isEditavel =
    (modoAdequacao && emAdequacaoDesteCampo) || (!modoAdequacao && !disabled);

  useEffect(() => {
    const selected = selectedOptions[data.id] || {};
    setSelectedMainOption(selected.resposta || "");
    setSelectedPaths(selected.caminhos || {});

    if (
      data.title === "1. AÇÃO INTERNACIONAL" &&
      (selected.resposta === "NÃO" || selected.resposta === "")
    ) {
      localStorage.setItem("alternativaNivel1", "");
      localStorage.setItem("alternativaNivel2", "");
      localStorage.setItem("alternativaNivel3", "");
    }
  }, [selectedOptions, data.id]);

  const updateSelectedOptions = (resposta, caminhos) => {
    onOptionSelect(data.id, { resposta, caminhos });
  };

  const handleMainOptionChange = (value) => {
    setSelectedMainOption(value);
    setSelectedPaths({});
    updateSelectedOptions(value, {});
  };

  const handlePathChange = (pathKey, value) => {
    const pathLevel = pathKey.split(".").length;
    const newSelectedPaths = Object.keys(selectedPaths).reduce((acc, key) => {
      const keyLevel = key.split(".").length;
      if (keyLevel === pathLevel || key.startsWith(pathKey + ".")) return acc;
      acc[key] = selectedPaths[key];
      return acc;
    }, {});
    newSelectedPaths[pathKey] = value;
    setSelectedPaths(newSelectedPaths);
    updateSelectedOptions(selectedMainOption, newSelectedPaths);

    if (pathLevel === 1) {
      localStorage.setItem("alternativaNivel1", value);
      localStorage.setItem("alternativaNivel2", "");
      localStorage.setItem("alternativaNivel3", "");
    }
    if (pathLevel === 2) {
      localStorage.setItem("alternativaNivel2", value);
      localStorage.setItem("alternativaNivel3", "");
    }
    if (pathLevel === 3) {
      localStorage.setItem("alternativaNivel3", value);
      localStorage.setItem("alternativaNivel4", "");
    }
  };

  const mapHistoricoToInitialValue = (historicoItem) => {
    if (!historicoItem) return {};
    return {
      status:
        historicoItem.conforme === true
          ? "CONFORME"
          : historicoItem.conforme === false
            ? "NAO_CONFORME"
            : null,
      observacao: historicoItem.observacao || "",
      solicitadoEm: historicoItem.dataSolicitacao || "",
      obsAnalista: historicoItem.obsAnalista || "",
      adequadoEm: historicoItem.dataAdequacao || "",
      obsSindicato: historicoItem.obsSindicato || "",
      adequacaoRealizada: historicoItem.adequacaoRealizada || false,
    };
  };

  const temSolicitacaoAdequacao = (campo, historico, modoAdequacao) => {
    if (!modoAdequacao || !campo) return false;

    const slugOrigem =
      campo?.idCampoJson || campo?.nomeArquivo || campo?.titulo || "";
    const campoSlug = slugify(slugOrigem).replace("ou", "e");

    const historicoKeys = Object.keys(historico || {});

    const temaSlug = slugify(data.idCampoJson).replace("ou", "e");

    const matchKey = historicoKeys.find(
      (key) =>
        slugify(key).replace("ou", "e") === campoSlug ||
        slugify(key).replace("ou", "e") === temaSlug,
    );

    if (
      matchKey &&
      typeof historico[matchKey]?.dataSolicitacao === "string" &&
      historico[matchKey]?.adequacaoRealizada !== true
    ) {
      return true;
    }
    return false;
  };

  const renderUploadButtons = (campo) => {
    const podeTrocarArquivo =
      modoAdequacao && temSolicitacaoAdequacao(campo, historico, modoAdequacao);
    const podeExcluirArquivo = !modoAdequacao && isEditavel;

    return (
      <div className="mt-2">
        <UploadSection
          idResposta={idResposta}
          nomeArquivo={campo.nomeArquivo}
          onUpload={(nome, files) => onFileUpload(nome, files)}
          uploadedFiles={uploadedFiles}
          podeTrocarArquivo={podeTrocarArquivo}
          podeExcluirArquivo={podeExcluirArquivo}
          disabled={!isEditavel}
        />
      </div>
    );
  };

  const renderAlternatives = (alternativas, depth = 0, path = []) => {
    return (
      <>
        {alternativas.map((alt, idx) => {
          const altKey = alt.valor || alt.titulo;
          const currentPath = [...path, altKey];
          const pathKey = currentPath.filter(Boolean).join(".");
          const isSelected = selectedPaths[pathKey] === altKey;

          return (
            <div key={idx} className={`ms-${depth * 3}`}>
              <Form.Check
                type="radio"
                label={altKey}
                name={`alt-${data.id}-${depth}-${path.join("-")}`}
                checked={isSelected}
                onChange={() => handlePathChange(pathKey, altKey)}
                disabled={!isEditavel}
              />
              {isSelected && alt.campo && (
                <div className="mt-2">
                  {alt.campo.map((campo, i) => {
                    const _podeTrocarArquivo =
                      campo?.nomeArquivo &&
                      temSolicitacaoAdequacao(campo, historico, modoAdequacao);

                    if (campo.tipoCampo === "radio") {
                      return (
                        <div key={i} className="ms-3">
                          {renderAlternatives(
                            campo.alternativa,
                            depth + 1,
                            currentPath,
                          )}
                        </div>
                      );
                    }

                    return renderUploadButtons(campo);
                  })}
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  };

  const slugKey = slugify(data.idCampoJson);
  const historicoEntryKey = Object.keys(historico || {}).find(
    (key) => slugify(key) === slugKey,
  );
  const historicoItem = historicoEntryKey ? historico[historicoEntryKey] : null;

  return (
    <Card className={`mb-4 ${hasError ? "error-card" : ""}`}>
      <Card.Body>
        <button
          type="button"
          onClick={handleToggle}
          className="w-100 d-flex justify-content-between align-items-center"
          style={{
            background: "transparent",
            border: "none",
            padding: 0,
            textAlign: "left",
          }}
          aria-expanded={isOpen}
        >
          <div className="d-flex align-items-center gap-2">
            {isOpen ? (
              <FaChevronDown style={{ color: "#6c757d" }} />
            ) : (
              <FaChevronRight style={{ color: "#6c757d" }} />
            )}

            <Card.Title className="fw-bold mb-0">{data.title}</Card.Title>
          </div>

          <span />
        </button>

        {isOpen && (
          <Form className="mt-2">
            {data.criterios.map((criterio, idx) => {
              const campos = criterio.campo || [];
              const isMainRadio =
                idx === 0 &&
                campos.length > 0 &&
                campos[0].tipoCampo === "radio" &&
                !campos[0].nomeArquivo;

              return (
                <div key={idx} className="mb-3">
                  {criterio.titulo &&
                    (isMainRadio || selectedMainOption === "SIM") && (
                      <Form.Label className="fw-semibold">
                        {criterio.titulo}
                      </Form.Label>
                    )}

                  {isMainRadio && (
                    <Form.Group className="mt-2">
                      <Form.Check
                        type="radio"
                        label="SIM"
                        name={`main-${data.id}`}
                        value="SIM"
                        checked={selectedMainOption === "SIM"}
                        onChange={() => handleMainOptionChange("SIM")}
                        disabled={!isEditavel}
                      />
                      <Form.Check
                        type="radio"
                        label="NÃO"
                        name={`main-${data.id}`}
                        value="NÃO"
                        checked={selectedMainOption === "NÃO"}
                        onChange={() => handleMainOptionChange("NÃO")}
                        disabled={!isEditavel}
                      />
                    </Form.Group>
                  )}

                  {selectedMainOption === "SIM" &&
                    campos
                      .filter((_, i) => !isMainRadio || i > 0)
                      .map((campo, i) => {
                        if (campo.tipoCampo === "radio") {
                          return (
                            <div key={i} className="mt-2">
                              {renderAlternatives(campo.alternativa)}
                            </div>
                          );
                        }
                        if (campo.tipoCampo === "pdf") {
                          return renderUploadButtons(campo);
                        }
                        return null;
                      })}
                </div>
              );
            })}
          </Form>
        )}
      </Card.Body>

      {historicoItem?.dataSolicitacao && (
        <History
          idCampo={slugKey}
          initialValue={mapHistoricoToInitialValue(historicoItem)}
          onChange={onAnalysisChange}
          isSindicato={true}
        />
      )}
    </Card>
  );
};

export default Topic;
